import { render, staticRenderFns } from "./teacher-dashboard.vue?vue&type=template&id=1ee98070&"
import script from "./teacher-dashboard.vue?vue&type=script&lang=js&"
export * from "./teacher-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports